import ApplicationController from "./application_controller"

// Reusable, backend-agnostic upload persister for the shared .photo-upload widget
// (shared/givsum3/_photo_upload.html.haml). Never used standalone -- the partial composes it
// onto the same element as photo_upload_controller.js (data-controller="photo-upload
// remote-image-upload-v3") and wires the action for you when you pass upload_url to the
// partial. Listens for photo-upload:upload and POSTs/PATCHes the picked file's data URI to any
// endpoint that accepts a `<param_key>[remote_image_url]` data-URI param -- e.g. this app's
// profile_image/header_logo/theme_image controllers (see docs/givsum3_08_july.md). Kept
// separate from photo_upload_controller so that widget stays a generic preview/zoom component
// with no backend knowledge of its own.
//
// Usage (via the partial, not directly):
//   = render partial: "shared/givsum3/photo_upload", locals: {
//       label: "Primary Logo", image_src: (existing_image_url if present),
//       upload_url: organization_profile_image_path(@organization),
//       upload_method: (@organization.profile_image.present? ? "patch" : "post"),
//       param_key: "profile_image"
//     }
export default class extends ApplicationController {
  // This app's Stimulus core is v2.0.0 (pre-Hotwired) -- it only accepts a bare constructor
  // (String/Number/Boolean/Array/Object) per value, NOT the modern { type, default } shorthand.
  // The latter throws "Unknown value type constant" and aborts the whole controller-load loop,
  // silently breaking every controller after it. The partial always supplies upload_method
  // (defaulting to "post" server-side), so no JS-side default is needed anyway.
  static values = {
    url: String,
    method: String,
    paramKey: String
  }

  upload(event) {
    const { dataUrl } = event.detail
    if (!dataUrl) return

    const formData = new FormData()
    formData.append(`${this.paramKeyValue}[remote_image_url]`, dataUrl)

    const buttons = this.element.querySelectorAll("button") // Remove/Select File/Upload -- lock all three during the request
    const uploadBtn = this.element.querySelector(".btn-primary")
    const originalText = uploadBtn.textContent
    buttons.forEach(btn => { btn.disabled = true })
    uploadBtn.textContent = "Uploading..."

    fetch(this.urlValue, {
      // fetch() auto-uppercases get/post/put/delete/head/options if passed lowercase, but NOT
      // patch (a Fetch-spec quirk) -- a lowercase "patch" method-value silently fails to match
      // any Rails route. Force uppercase explicitly so this works regardless of casing.
      method: this.methodValue.toUpperCase(),
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error(`Upload failed (${response.status})`)
        window.location.reload()
      })
      .catch(() => {
        buttons.forEach(btn => { btn.disabled = false })
        uploadBtn.textContent = originalText
        window.Gv3Toast.error("Sorry, that image couldn't be uploaded. Please try again.")
      })
  }
}
